// extracted by mini-css-extract-plugin
export default {"sidebarMenu":"Sidebar_sidebarMenu__ysKkV","active":"Sidebar_active__BOc5J"};